// import { Grid, Toolbar } from "@mui/material";
// import React from "react";
// import Sidebar from "../../../components/Qna/Sidebar";
// import { Link } from "react-router-dom";
// import FilterListIcon from "@material-ui/icons/FilterList";
// import { Avatar, Typography, Chip, Box } from "@mui/material";

// function User() {
  
//   return (
//     <Grid container>
//       <Grid item container xs={12}>
//         <Grid
//           item
//           xs={2}
//           sx={{
//             position: "sticky",
//             top: 0,
//             alignSelf: "flex-start",
//             height: "100vh",
//             overflowY: "auto",
//           }}
//         >
//           <Toolbar style={{ minHeight: "30px" }} sx={{ height: "0.5rem" }} />
//           <Sidebar />
//         </Grid>

//         <Grid item xs={10}>
//           <div className="main">
//             <div className="main-container">
//               <div className="main-top">
//                 <h2>Users</h2>
//               </div>
//               <div className="main-desc">
//                 <h6 className="question length">questions</h6>
//                 <div className="main-filter">
//                   <div className="main-tabs">
//                     <div className="main-tab">
//                       <Link to="/">Newest</Link>
//                     </div>
//                     <div className="main-tab">
//                       <Link to="/">Active</Link>
//                     </div>
//                     <div className="main-tab">
//                       <Link to="/">Bountied</Link>
//                     </div>
//                     <div className="main-tab">
//                       <Link to="/">Unanswered</Link>
//                     </div>
//                     <div className="main-tab">
//                       <Link to="/">More</Link>
//                     </div>
//                   </div>
//                   <div className="main-filter-item">
//                     <FilterListIcon />
//                     <p className="p2" style={{ marginBottom: "0.3rem" }}>
//                       Filter
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="container">
//             <div className="row">
//              <Link to="/userdetails">
//              <div className="col-md-3">
//                 <Box
//                   display="flex"
//                   flexDirection="column"
//                   alignItems="center"
//                   p={0.5} // Reduce padding further
//                   border={1}
//                   borderRadius={1}
//                   width={160} // Smaller width for the card
//                   sx={{ maxWidth: 180 }} // Optional: maximum width for the card
//                 >
//                   {/* Avatar and Name Section */}
//                   <Avatar
//                     alt="Dan Beam"
//                     src="https://i.pravatar.cc/150?img=3" // Smaller avatar size
//                     sx={{ width: 40, height: 40, mb: 0.5 }} // Even smaller avatar
//                   />
//                   <Typography variant="h6" fontSize="0.875rem">
//                     Dan Beam
//                   </Typography>

//                   {/* Location */}
//                   <Typography
//                     variant="body2"
//                     color="textSecondary"
//                     fontSize="0.75rem"
//                   >
//                     Venice, CA
//                   </Typography>

//                   {/* Followers Count */}
//                   <Typography
//                     variant="body2"
//                     color="textSecondary"
//                     fontSize="0.75rem"
//                     mt={0.5}
//                   >
//                     215 Followers
//                   </Typography>

//                   {/* Skills */}
//                   <Box mt={0.5}>
//                     <Chip
//                       label="JS"
//                       size="small"
//                       sx={{ marginRight: 0.5, fontSize: "0.75rem" }}
//                     />
//                     <Chip
//                       label="HTML"
//                       size="small"
//                       sx={{ marginRight: 0.5, fontSize: "0.75rem" }}
//                     />
//                     <Chip
//                       label="CSS"
//                       size="small"
//                       sx={{ fontSize: "0.75rem" }}
//                     />
//                   </Box>
//                 </Box>
//               </div>
//              </Link>
             
              
              
//             </div>
//           </div>
//         </Grid>
//       </Grid>
//     </Grid>
//   );
// }

// export default User;
import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Divider, ListItem, ListItemText, Avatar, Toolbar, Grid } from '@mui/material';
import UserProfile from './UserProfile'; // Import UserProfile component
import UserActivity from './UserActivity'; // Import UserActivity component
import UserSaveDetails from './UserSaveDetails'; // Import UserSaveDetails component
import Sidebar from '../../../components/Qna/Sidebar';

const UserProfilePic = () => {
  const user = JSON.parse(localStorage.getItem("UserDetails")); // Parse user data from localStorage
	console.log("User data in Headerjjjjjjjjjjjjjj:", user);
  const userName = user ? user.userName : "Guest"; 

  // Define avatar URL, fallback to a default image if not found
  const avatarUrl = user && user.organisation && user.organisation.photo ? user.organisation.photo : "  "; 


  // State to track which component should be shown
  const [showProfile, setShowProfile] = useState(false);
  const [showUserSaveDetails, setShowUserSaveDetails] = useState(false); // Default to show UserSaveDetails
  const [showActivity, setShowActivity] = useState(false); // Default to hide Activity

  // Handle the 'Profile' button click
  // const handleProfileClick = () => {
  //   setShowUserSaveDetails(false); // Hide UserSaveDetails when Profile is clicked
  //   setShowProfile(true); // Show Profile
  //   setShowActivity(false); // Hide Activity component when Profile is clicked
  // };

  // Handle the 'Activity' button click
  // const handleActivityClick = () => {
  //   setShowUserSaveDetails(false); // Hide UserSaveDetails when Activity is clicked
  //   setShowActivity(true); // Show Activity
  //   setShowProfile(false); // Hide Profile component when Activity is clicked
  // };

  // Handle the 'Saves' button click
  const handleUserSaveDetails = () => {
    setShowActivity(false); // Hide Activity
    setShowProfile(false); // Hide Profile
    setShowUserSaveDetails(true); // Show UserSaveDetails
  };
  

  return (

    <Grid container>
			{/* Sidebar - Fixed */}
			<Grid item container xs={12}>
				<Grid
					item
					xs={2}
					sx={{
						position: "sticky",
						top: 0,
						alignSelf: "flex-start", // Ensure it sticks within its container
						height: "80vh",
						overflowY: "auto",
						// mt: 4,
					}}>
					<Toolbar style={{ minHeight: "30px" }} sx={{ height: "0.5rem" }} />
					<Sidebar />
				</Grid>

				<Grid item xs={10}>
        <div>
      <Box
        sx={{
          padding: 3,
          width: '75vw',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          border: '1px solid #ccc',
          borderRadius: 2,
          boxSizing: 'border-box',
        }}
      >
        {/* User avatar and name */}
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
          <Box display="flex" alignItems="center">
            <Avatar   alt={userName} src={avatarUrl} sx={{ width: 70, height: 70, marginRight: 2 }} />
            <Box>
              <Typography variant="h6">{userName
                
                }</Typography>
              <Box display="flex" flexDirection="row" alignItems="center">
                <Typography variant="body2" color="textSecondary" sx={{ marginRight: 2 }}>
                  Member for 
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ marginRight: 2 }}>
                  Last seen 
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Visited consecutive
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Divider />

        {/* Buttons for profile, activity, saves, settings */}
        <Box display="d-flex" flexDirection="column" mt={2} mb={2}>
          {/* <Button variant="text" color="primary" onClick={handleProfileClick}>Profile</Button> */}
          {/* <Button variant="text" color="primary" onClick={handleActivityClick}>Activity</Button> */}
          <Button variant="text" color="primary" onClick={handleUserSaveDetails}>Saves</Button>
          {/* <Button variant="text" color="primary" >Settings</Button> */}
        </Box>

        <Divider />

        {/* Show UserProfile, UserActivity, or UserSaveDetails based on state */}
        <Box mt={0}>
          {showActivity && (
            <ListItem button>
              <ListItemText
                primary={
                  <Box sx={{ padding: 2 }}>
                    <UserActivity /> 
                  </Box>
                }
              />
            </ListItem>
          )}

          {showProfile && (
            <ListItem button>
              <ListItemText
                primary={
                  <Box>
                    <UserProfile /> {/* This will be shown when Profile is clicked */}
                  </Box>
                }
              />
            </ListItem>
          )}

          {showUserSaveDetails && (
            <ListItem button>
              <ListItemText
                primary={
                  <Box sx={{ padding: 2 }}>
                    <UserSaveDetails /> {/* This will be shown when Saves is clicked */}
                  </Box>
                }
              />
            </ListItem>
          )}
        </Box>
      </Box>
    </div>
				</Grid>
			</Grid>
		</Grid>
  );
};

export default UserProfilePic;
